<template>
  <Loader :show="loading" v-if="loading"></Loader>
  <MDBRow v-else>
    <MDBCol xl="5" cols="12" class="mb-1">
      <div class="textBox textBox--small h-auto column-order">
        <div v-if="training" v-html="description"></div>
        <div>
          <router-link
            v-if="!isWholesaler"
            :to="{ name: 'trainingForm', params: { id: route.params.id } }"
            class="btn btn-danger text-white mt-4">
            {{
              trainingDone
                ? $t("trainings.single.doneDownloadCertificate")
                : $t("global.buttons.toQuiz")
            }}
          </router-link>
        </div>
      </div>
    </MDBCol>
  </MDBRow>
</template>

<script setup>
import Loader from "@/components/General/Loader/index";
import { MDBRow, MDBCol } from "mdb-vue-ui-kit";
import { computed, ref, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const route = useRoute();

const training = computed(() => store.getters.getTraining);
const profile = computed(() => store.getters.getProfile);
const storedLocale = computed(() => store.getters.getCurrentLocale);
const loading = computed(() => {
  const currentTraining = training.value;
  const trainingId = currentTraining?.id ?? currentTraining?.hashId;

  return !currentTraining?.title || String(trainingId) !== String(route.params.id);
});

const user = computed(() => store.getters.getMe);
const trainingDone = computed(() => store.getters.getTrainingResult);
const isWholesaler = ref(false);
const description = computed(() => {
  if (!training.value || !profile.value || !storedLocale.value) return null;

  const locale = storedLocale.value;
  const translatedDescription = training.value?.description?.[locale];
  const translatedDefaultDescription = training.value?.default_description?.[locale];

  const canReceivePoints =
    training.value.can_receive_points &&
    training.value.can_receive_points.includes(profile.value.group_id);

  if (canReceivePoints && translatedDescription) {
    return translatedDescription;
  }

  return translatedDefaultDescription || translatedDescription || "";
});

watch(user, async (newVal) => {
  if (newVal && newVal.roles.find((item) => item.name == "wholesaler")) {
    isWholesaler.value = true;
  }
});

onMounted(async () => {
  await store.dispatch("me");
  await store.dispatch("loadTrainingById", route.params.id);
});
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
</style>
